import { StoryblokMultilink } from '@definitions/types/storyblokBaseTypes'

/**
 * Creates a mock StoryblokMultilink
 * @param overrides - Partial fields to override defaults
 * @returns Complete StoryblokMultilink mock
 */
export function createStoryblokMultilink(
  overrides: Partial<StoryblokMultilink> = {}
): StoryblokMultilink {
  return {
    fieldtype: 'multilink',
    id: '',
    url: '',
    cached_url: '',
    linktype: 'story',
    ...overrides,
  }
}
